import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FILE_ATTACHMENTS_FETCH = createAsyncActionTypes('FILE_ATTACHMENTS_FETCH');